<template>
  <Popper
    :class="popperClass"
    :options="options"
    :trigger="trigger">
    <div
      class="popper"
      :class="arrowPlacement">
      <slot name="popperContent"></slot>
    </div>
    <!-- ATTENTION: you have to add a <span> or <div> in order to trigger any content -->
    <slot
      slot="reference"
      name="triggerContent"></slot>
  </Popper>
</template>

<script>
  import Popper from 'vue-popperjs';
  import 'vue-popperjs/dist/vue-popper.min.css';

  export default {
    components: { Popper },
    computed: {
      arrowPlacement() {
        switch(this.arrowPosition) {
          case `left`:
            return `popper--arrow-left`;
          case `right`:
            return `popper--arrow-right`;
          default:
            return ``;
        }
      },
    },
    props: {
      arrowPosition: {
        default: ``,
        type: String,
      },
      options: {
        default: () => {},
        type: Object,
      },
      popperClass: {
        default: ``,
        type: String,
      },
      trigger: {
        default: `hover`,
        type: String,
      },
    },
  };
</script>

<style lang="less">
  .popper {
    background-color: #fff !important;
    border: 1px solid #e5e5e5;
    padding: 20px;

    &--arrow-left .popper__arrow {
      left: 0 !important; // override inline style from popper
    }

    &--arrow-right .popper__arrow {
      left: auto !important; // override inline style from popper
      right: 0 !important;
    }

    &__list,
    &__list-item {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
  }
</style>
